<template>
    <div class="premium-interior-flex weather-interior flex items-center xl:flex-row xl:flex-no-wrap md:flex-wrap md:flex-col">
        <div class="premium-interior-right xl:w-6/12 xl:order-1 xl:py-0 md:w-w420 md:py-6 md:order-2">
            <div class="premium-interior-info-width xl:w-w420 xl:px-spc19 ml-auto md:w-full md:px-0">
                <h3 class="text-14 font-bold text-white py-2 leading-spc5 tracking-space2">
                    All-Weather Comfort
                </h3>
                <p class="text-14 leading-spc5 text-white">
                    Enhance comfort with front and rear seat heaters, a heated steering wheel, wiper blade defrosters and washer nozzle heaters.
                </p>
            </div>
        </div>
        <div class="premium-interior-left relative xl:w-6/12 xl:order-2 md:w-w550 md:ml-auto md:mr-auto md:order-1">
            <img src="../../../assets/images/premium2.jpg" alt="Premium" class="block w-full pr-spc27 md:pr-0">
        </div>
    </div>
</template>

<script>
    export default {
        name: "InteriorWeather"
    }
</script>

<style scoped>

</style>